import EditPDF from './EditPDF';

export default EditPDF;
